import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { tokens } from "./tokens";
import CodeChip from "./CodeChip";
import StatusPill from "./StatusPill";

/**
 * Patient Strip (§5.5) — encabezado clínico del paciente en una línea densa.
 * Nombre, edad/sexo, CIP_ID (mono), location, PCP, membresía y badge de
 * sensibilidad si aplica. No es un card de marketing: sin avatar grande.
 *
 * @param {Object} patient
 * @param {string} patient.name
 * @param {number} [patient.age]
 * @param {string} [patient.gender]
 * @param {string|number} [patient.cipId]
 * @param {string} [patient.location]
 * @param {string} [patient.pcp]
 * @param {string} [patient.membership]
 * @param {boolean} [patient.sensitive] - break-the-glass
 * @param {React.ReactNode} [actions] - acciones a la derecha
 */
export default function PatientStrip({ patient = {}, actions, sx }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        flexWrap: "wrap",
        px: 2,
        py: 1.25,
        bgcolor: tokens.surface,
        border: `1px solid ${tokens.line}`,
        borderRadius: "6px",
        ...sx,
      }}
    >
      <Typography
        sx={{ fontFamily: tokens.fontUI, fontSize: 16, fontWeight: 600, color: tokens.ink }}
      >
        {patient.name}
      </Typography>
      {(patient.age || patient.gender) && (
        <Typography sx={{ fontSize: 13, color: tokens.ink2 }}>
          {[patient.age && `${patient.age}y`, patient.gender].filter(Boolean).join(" · ")}
        </Typography>
      )}
      {patient.cipId && <CodeChip code={String(patient.cipId)} />}
      {patient.location && (
        <Typography sx={{ fontSize: 13, color: tokens.ink2 }}>{patient.location}</Typography>
      )}
      {patient.pcp && (
        <Typography sx={{ fontSize: 13, color: tokens.ink3 }}>PCP: {patient.pcp}</Typography>
      )}
      {patient.membership && (
        <Typography sx={{ fontSize: 13, color: tokens.ink3 }}>{patient.membership}</Typography>
      )}
      {patient.sensitive && <StatusPill tone="crit" label="Sensitive — break-the-glass" dense />}
      <Box sx={{ flex: 1 }} />
      {actions}
    </Box>
  );
}
